import toast from "react-hot-toast";

/** Only absolute http(s) URLs are safe to open from the admin UI. */
export function isSafeHttpUrl(value: string | null | undefined): boolean {
  if (!value?.trim()) return false;
  try {
    const url = new URL(value.trim());
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
}

export function isApprovedDonationStatus(
  status: string | null | undefined
): boolean {
  const normalized = (status || "").toLowerCase().trim();
  return normalized === "published" || normalized === "active";
}

/** Open a validated http(s) link in a new tab. Returns false if blocked. */
export function openSafePaymentLink(link: string | null | undefined): boolean {
  if (!link?.trim()) return false;
  if (!isSafeHttpUrl(link)) {
    toast.error(
      "This payment link is not a valid http(s) URL and cannot be opened."
    );
    return false;
  }
  window.open(link.trim(), "_blank", "noopener,noreferrer");
  return true;
}
